if (!customElements.get("testimonials-with-filters")) {
  class TestimonialsWithFilters extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.filters = this.querySelectorAll(
        ".testimonials-with-filters__filter"
      );

      this.filters.forEach((filter) =>
        filter.addEventListener("click", (event) => {
          this.filters.forEach((filter) =>
            filter.classList.toggle(
              "testimonials-with-filters__filter--active",
              filter == event.target
            )
          );

          this.checkReview();
        })
      );

      this.reviews = this.querySelectorAll(
        ".testimonials-with-filters__review-block"
      );

      this.activeFilter = this.querySelector(
        ".testimonials-with-filters__filter--active"
      );

      this.checkReview();
    }

    checkReview() {
      this.reviews.forEach((review) => {
        const typeList = review.dataset.reviewType
          ?.split("|")
          .map((t) => t.trim());

        const activeType = this.querySelector(
          ".testimonials-with-filters__filter--active"
        ).dataset.filterType.trim();

        review.classList.toggle(
          "testimonials-with-filters--hide",
          !typeList?.includes(activeType)
        );
      });
    }
  }

  customElements.define("testimonials-with-filters", TestimonialsWithFilters);
}
